import Link from "next/link";
import getConfig from "next/config";

import AppleMenuIcon from "@components/Icons/AppleMenuIcon";
import ImageWithFallback from "@components/ImageWithFallback";
import { resizeImage } from "@lib/helpers";

const {
  publicRuntimeConfig: {
    settings: { websiteStatics },
  },
} = getConfig();

const AppleNavbar = ({ menu }) => (
  <>
    <Link href="/shop/apple">
      <a className="md:hidden">
        <AppleMenuIcon />
      </a>
    </Link>

    <Link href="/shop/apple">
      <a className="hidden md:block">
        <AppleMenuIcon width="100" height="auto" />
      </a>
    </Link>

    <menu className="flex text-[12px] gap-[24px] md:gap-[40px] overflow-auto scrollbar-none">
      {menu.map((menuItem, index) => (
        <li key={index} className="min-w-fit p-[12px] hover:opacity-80">
          <Link href={menuItem.url}>
            <a
              title={menuItem.name}
              className="flex flex-col gap-[8px] items-center"
            >
              <span className="rounded-full bg-white p-[12px]">
                <ImageWithFallback
                  src={
                    menuItem.image ? resizeImage(menuItem.image, "75x75") : null
                  }
                  alt={menuItem.name}
                  fallback={`${websiteStatics}/images/applePlaceholder.svg`}
                  className="w-[48px] h-[48px] aspect-square object-contain"
                />
              </span>
              {menuItem.name}
            </a>
          </Link>
        </li>
      ))}
    </menu>
  </>
);

export default AppleNavbar;
